// src/digital-presence/data/social-media/shared/categoryColorMapping.js
export const categoryColorMapping = {
  // ContentFocus Categories — 6-category taxonomy (M005/S01, active for new posts)
  "Clinical Evidence": "#0088FE",         // Bright Blue
  "Product & Technology": "#00C49F",      // Vibrant Teal
  "Education & Case Sharing": "#3DBB6D", // Leafy Green
  "Events & Congresses": "#F66D9B",      // Pink
  "Company & Strategy": "#BB6BD9",       // Medium Purple
  "Other": "#9E9E9E",                    // Medium Grey

  // ContentFocus Categories — legacy 13-category taxonomy (kept for old posts)
  "Product Update": "#00C49F",
  "Clinical Results": "#0088FE",
  "Regulatory News": "#FF8042",
  "Company News": "#00B9D0",
  "Partnership News": "#BB6BD9",
  "Industry Insights": "#FFBB28",
  "Educational Content": "#3DBB6D",
  "Event Announcement": "#F66D9B",
  "Patient Story": "#82D782",
  "HCP Testimonial": "#8854D9",
  "Award Recognition": "#FFDA63",
  "Careers / Hiring": "#5AC8FA",
  "Other": "#9E9E9E",
};

// Revised default colors for any categories that might somehow not be in the mapping yet.
export const defaultCategoryColors = [
  "#6B7AFF", // Light Indigo
  "#F178B6", // Soft Magenta
  "#3DCCC7", // Bright Cyan
  "#FFD05B", // Pale Yellow
  "#A06AF9", // Light Violet
  "#FF8C42", // Tangerine
  "#5ABA8F", // Sea Green
  "#29B6F6", // Light Blue (Material)
  "#AB47BC", // Purple (Material)
  "#EC866C", // Terracotta
  "#9CCC65", // Light Green (Material)
  "#7E57C2", // Deep Purple (Material)
  "#FFEE58", // Yellow (Material)
  "#EF5350", // Red (Material)
  "#26A69A"  // Teal (Material)
];

export const getCategoryColor = (category) => {
  if (categoryColorMapping[category]) {
    return categoryColorMapping[category];
  }
  // Fallback for unmapped categories:
  // Simple consistent hash function to pick a color from defaultCategoryColors
  // This ensures the same unmapped category always gets the same fallback color
  let hash = 0;
  for (let i = 0; i < category.length; i++) {
    const char = category.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }
  const index = Math.abs(hash) % defaultCategoryColors.length;
  return defaultCategoryColors[index];
}; 